/**
 * Page Heading block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS. GSAP is lazy-loaded
 * only when motion is allowed. Always above the fold, so this fires immediately
 * on load rather than on scroll.
 */

import './index.scss';

const pageHeadings = document.querySelectorAll('.page-heading');

if (pageHeadings.length) {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	if (!reduceMotion) {
		(async () => {
			const { gsap } = await import('gsap');

			pageHeadings.forEach((block) => {
				const ctx = gsap.context(() => {
					const breadcrumbs = block.querySelector('.page-heading__breadcrumbs');
					const heading = block.querySelector('.page-heading__heading');

					const tl = gsap.timeline({
						defaults: {
							ease: 'power3.out',
							duration: 0.8,
						},
					});

					gsap.set([breadcrumbs, heading].filter(Boolean), { opacity: 0, y: 20 });

					if (breadcrumbs) {
						tl.to(breadcrumbs, { opacity: 1, y: 0 }, 0);
					}

					if (heading) {
						tl.to(heading, { opacity: 1, y: 0 }, 0.15);
					}
				}, block);

				block._gsapCtx = ctx;
			});
		})();
	}
}
